import { createContext } from 'react';

export type ContextType = {
  isCompanyErrorComponentMounted: boolean,
  isSetCompanyErrorComponentMounted: (a: boolean) => void,
  isBDTabClicked: boolean,
  setIsBDTabClicked: (a: boolean) => void,
  isEuBd: boolean,
  isUnitedStates: boolean,
  searchResultsContainerReference: React.RefObject<HTMLDivElement>
}
export const AppContext = createContext<ContextType | null>(null);
